import { render, staticRenderFns } from "./dimensionsandrates.vue?vue&type=template&id=1df1b65c&scoped=true&"
import script from "./dimensionsandrates.vue?vue&type=script&lang=js&"
export * from "./dimensionsandrates.vue?vue&type=script&lang=js&"
import style0 from "./dimensionsandrates.vue?vue&type=style&index=0&id=1df1b65c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df1b65c",
  null
  
)

export default component.exports